<template>
  <div class="payment_successful_box">
    <van-nav-bar left-arrow fixed title="付款成功"/>
    <div class="successful_content">
      <van-icon class="success_icon" name="success" color="#0FBC54" size="100"/>
      <p class="success_text">付款成功</p>
      <p class="success_tips">问诊已付款成功，我们会尽快审方发货</p>
    </div>
  </div>
</template>
<script>
export default {
  name: "paymentSuccessful",
  data() {
    return {}
  }
}
</script>

<style scoped lang="scss">
.payment_successful_box {
  display: flex;
  flex-direction: column;
  background: #f4f4f4;
  font-size: 14px;
  padding-top: 40px;
  box-sizing: border-box;
}

.successful_content {
  background: #FFFFFF;
  margin-top: 10px;
  text-align: center;
  min-height: calc(100vh - 50px);

  .success_icon {
    margin-top: 60px;
  }

  .success_text {
    font-size: 20px;
    font-weight: bold;
    margin-top: 10px;
  }

  .success_tips {
    font-size: 16px;
    margin-top: 10px;
  }
}


</style>